// extracted by mini-css-extract-plugin
export var dividerLine = "_4t-0";
export var errorBackground = "_4t-1";